import type { EntryState as PillState } from '@cou/admin-ui';

/**
 * Maps the backend's EntryStatus (CONTEXT → Entry) onto the admin-ui StatusPill's lowercase state
 * set, mirroring contests/state-pill.ts. An unrecognised status reads as `editable` — the most
 * neutral pill — rather than throwing a whole Entries tab away over one unknown row.
 */
export function entryPillState(status: string): PillState {
  const key = status.toLowerCase();
  return key === 'locked' || key === 'settled' || key === 'voided' ? key : 'editable';
}
